
import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', align: 'start', value: 'number_index', width: '10' },
  { text: 'Nama Promo', value: 'promo_name', width: '150', align: 'center' },
  { text: 'Jenis Promo', value: 'jenis_promo', width: '150', align: 'center' },
  { text: 'Start Date', value: 'start_datetime', width: '250', align: 'center' },
  { text: 'End Date', value: 'end_datetime', width: '250', align: 'center' },
  { text: 'Jumlah Promo', value: 'total_promo', width: '150', align: 'center' },
  { text: 'Promo Tersedia', value: 'available_promo_quota', width: '150', align: 'center' },
  { text: 'Promo Terpakai', value: 'used_promo_quota', width: '150', align: 'center' },
  { text: 'Status', value: 'status', width: '100', align: 'center' },
  { text: 'Last Update', value: 'updated_at', align: 'center' },
  { text: 'Action', value: 'action', width: '100' }
]);



export const editedItem = {
  promo_type: '',
  bulk_id: '',
  promo_name: '',
  qr_method_npm: '',
  qr_method_cpm: '',
  payment_type_on_us: '',
  payment_type_off_us: '',
  start_datetime: '',
  end_datetime: '',
  min_transaction: '',
  promo_quota_per_merchant: '',
  promo_quota_per_customer: '',
  promo_quota_merchant_per_day: '',
  promo_quota_customer_per_day: '',
  jenis_promo: '',
  discount_type: '',
  percent: '',
  max_discount_amount: '',
  fix_amount: '',
  syarat_dan_ketentuan: '',
  status: '',
  bulk_upload_status: '',
};

export const search = {
  jenis_promo: '',
  start_datetime: [],
  end_datetime: [],
};

